import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProfileState {
  interests: Array<string>;
  learning_goals: Array<string>;
}

const INITIAL_STATE: ProfileState = {
  interests: [],
  learning_goals: [],
};

const profileSlice = createSlice({
  name: 'profile',
  initialState: INITIAL_STATE,
  reducers: {
    setInterests(state: ProfileState, action: PayloadAction<Array<string>>) {
      state.interests = action.payload;
    },
    setLearningGoals(state: ProfileState, action: PayloadAction<Array<string>>) {
      state.learning_goals = action.payload;
    },
    addInterest(state: ProfileState, action: PayloadAction<string>) {
      state.interests.push(action.payload);
    },
    addLearningGoal(state: ProfileState, action: PayloadAction<string>) {
      state.learning_goals.push(action.payload);
    },
    removeInterest(state: ProfileState, action: PayloadAction<string>) {
      state.interests = state.interests.filter((interest) => interest !== action.payload);
    },
    removeLearningGoal(state: ProfileState, action: PayloadAction<string>) {
      state.learning_goals = state.learning_goals.filter((goal) => goal !== action.payload);
    },
  },
});

export const {
  setInterests,
  setLearningGoals,
  addInterest,
  addLearningGoal,
  removeInterest,
  removeLearningGoal,
} = profileSlice.actions;

export default profileSlice.reducer;
